import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { buildHeaders, XmStore } from 'core/services';
import { StoreAction } from 'store/actions';
import { ApiChannel } from 'core/constants';
import { ModelBase } from 'store/model-base';
import { LineRetention } from './models/retention';

@Injectable()
export class IcopApi {
    public static lineRetention(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<LineRetention> {
        return http.get(`/xm/retention?lineIdKey=${params.lineId}`, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: ApiResponse) => LineRetention.create<LineRetention>(response))
        );
    }

}

ModelBase.fetchMapping[StoreAction.GET_LINE_RETENTION] = IcopApi.lineRetention;
